
export function consumed (devStart, devEnd) {
  const channel = ["1", "2", "3"]
  channel.forEach (c =>
    isConsumable(devStart["SensorType"+c]) ? ()=>{} : 
      devStart["Consumed"+c] = cons (devStart["ReadVal"+c], devEnd["ReadVal"+c])
  )
}
export function dynCons(arr, index) {
  ["1", "2", "3"].forEach (c => {
    if (!isIgnored(arr[index]["SensorType"+c])) {
      if (isReading(arr[index]["ReadVal"+c])) {
        const dyn = findReading(arr, "ReadVal"+c, index)
        if (dyn > -1)
          arr[index]["Consumed"+c] = Math.round((toNumber(arr[index]["ReadVal"+c]) - toNumber(arr[dyn]["ReadVal"+c])) *100)/100
      }
      else arr[index]["Consumed"+c] = 0
    }
    //console.log (c, index, arr[index]["ReadVal"+c], dyn, arr[dyn]["ReadVal"+c] )
  })
}

function findReading(arr, prop, index) {
  return arr.findLastIndex((i,iter) => i[prop] && i[prop] !== 4294967295 && iter < index);
} 
function cons (val1, val2) {
  const nv1 = toNumber (val1)
  const nv2 = toNumber(val2)
  return isReading(nv1) && isReading(nv2) ? Math.round((nv1 - nv2) *100) / 100: ''
}
function isReading (val) {
  const nv = toNumber(val)
  return isNumber(nv) && nv !== 4294967295
}
function toNumber(val) {
  return 'string' === typeof val ? parseFloat(val.replaceAll(',', '')) : val
}
function isNumber(val) {
  return typeof (val) === 'number' && Number.isFinite(val)
}
export function isIgnored(sensorType) {
  const temperatureTypes = [2, 3, 12, 13, 15, 255]
  const numType = typeof sensorType === 'string' ? parseInt(sensorType, 16) : sensorType
  return temperatureTypes.includes(numType)
}
export function isConsumable(sensorType) {
  const numType = typeof sensorType === 'string' ? parseInt(sensorType, 16) : sensorType
  return numType === 1 || isIgnored (sensorType)
}
